import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const SubscriptionsRepository = RepositoryFactory.get("subscriptions");

const actions = {
  subscribe({ dispatch }, subscribeData) {
    dispatch("loadings/enableLoadings", {}, { root: true });
    return SubscriptionsRepository.subscribe(subscribeData);
  },
  hideReminder({ dispatch, commit, state, rootState }) {
    let subscriptionId = rootState.users.user.subscription_id;

    if (subscriptionId !== null) {
      return SubscriptionsRepository.hideReminder(subscriptionId)
        .then(() => {
          commit("users/SET_USER_HIDE_SUBSCRIPTION_REMINDER", null, {
            root: true,
          });
        })
        .catch(() => {
          dispatch(
            "notifications/addError",
            {
              message: state.$t(
                `message.notifications.subscriptions.updateHideReminderError`,
              ),
            },
            { root: true },
          );
        });
    }
  },
};

export default {
  namespaced: true,
  actions,
};
